import Swiper, { Navigation } from 'swiper';

Swiper.use([ Navigation ]);

const SELECTOR = '.js-instagram-slider';

const map = new WeakMap<HTMLElement, any>();

function init(container: HTMLElement | Document = document) {

    const arrSlider = container.querySelectorAll<HTMLElement>(SELECTOR);

    arrSlider.forEach(slider => {
        if (window.matchMedia('(max-width: 650px)').matches) {
            let swiper = new Swiper(slider, {
                slidesPerView: 1.2,
                speed: 400,
                spaceBetween: 20,
            });

            map.set(slider, swiper);
        }
    });
}

function destroy(container: HTMLElement | Document = document) {
    Array.from(container.querySelectorAll<HTMLElement>(SELECTOR)).forEach((el) => {
        const slider = map.get(el);

        if (slider) {
            slider.destroy();
            map.delete(el);
        }
    });
}

const _module = { init, destroy };

export default _module;
